<template>
    <div class="headers_template" :class="{'hover':hoverIstrue||lastScrollTop>3.95*this.remRatio||linkToType != '/home','show':lastScrollTop == 0||scrollType == 'down'}"  @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
        <div class="marginAuto">
            <div class="left_box" v-if="!searchIsTrue">
                <div class="logo" @click="linkToTypeFun({link:'/home'},1)"></div>
                <div class="title text text1">{{$t('App.header.text1')}}</div>
            </div>
            <div class="nav_box" v-if="!searchIsTrue">
                <div class="nav_li" v-for="(item,index) in navList" :key="index+'nav_1'">
                    <div class="nav_btn text text1" @click="linkToTypeFun(item,1)">{{item.label}}</div>
                    <template v-if="item.list">
                        <div class="nav_dropdown_list" :class="'li_'+item.list.length">
                            <div class="dropdown_li text" v-for="(obj,idx) in item.list" :key="idx+'nav_2'" @click="linkToTypeFun(obj,2)">{{obj.label}}</div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="search_box" v-if="searchIsTrue">
                <el-input class="search_input" v-model="searchValue" @change="searchChange"  :placeholder="$t('App.header.text2')">
                    <img slot="suffix" src="../img/icon_search_h.png" />
                </el-input>
                <div class="btn text" @click="searchIsTrue = false">{{$t('App.header.text3')}}</div>
            </div>
            <div class="right_box" v-if="!searchIsTrue">
                <div class="search_btn" @click="searchIsTrue = true"></div>
                <div class="line_bar"></div>
                <div class="language_btn text1">EN</div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from 'vuex'
    export default {
        name: 'headers',
        data () {
            return {
                hoverIstrue:false,
                hoverTime: null,
                searchIsTrue:false,
                searchValue: null,
                navList:[
                    {
                        label:this.$t('App.header.text4'),
                        link: '/home',
                    },
                    {
                        label:this.$t('App.header.text5'),
                        id: '2',
                        list:[
                            {
                                link:'2_1',
                                label:this.$t('App.header.text6'),
                            },
                            {
                                link:'2_2',
                                label:this.$t('App.header.text7'),
                            },
                            {
                                link:'2_3',
                                label:this.$t('App.header.text8'),
                            },
                            {
                                link:'2_4',
                                label:this.$t('App.header.text9'),
                            },
                            {
                                link:'2_5',
                                label:this.$t('App.header.text10'),
                            },
                            {
                                link:'2_5',
                                label:this.$t('App.header.text11'),
                            },
                            {
                                link:'2_5',
                                label:this.$t('App.header.text12'),
                            }
                        ]
                    },
                    {
                        label:this.$t('App.header.text13'),
                        id: '3',
                        list:[
                            {
                                link:'/smartLighting',
                                label:this.$t('App.header.text14'),
                            },
                            {
                                link:'3-2',
                                label:this.$t('App.header.text15'),
                            },
                            {
                                link:'3_3',
                                label:this.$t('App.header.text16'),
                            },
                            {
                                link:'3_4',
                                label:this.$t('App.header.text17'),
                            },
                            {
                                link:'3_5',
                                label:this.$t('App.header.text18'),
                            },
                            {
                                link:'3_5',
                                label:this.$t('App.header.text19'),
                            }
                        ]
                    },
                    {
                        label:this.$t('App.header.text20'),
                        id: '4',
                        list:[
                            {
                                link:'4_1',
                                label:this.$t('App.header.text21'),
                            },
                            {
                                link:'4_2',
                                label:this.$t('App.header.text22'),
                            },
                            {
                                link:'4_3',
                                label:this.$t('App.header.text23'),
                            },
                            {
                                link:'4_4',
                                label:this.$t('App.header.text24'),
                            },
                        ]
                    },
                    {
                        label:this.$t('App.header.text25'),
                        id: '5',
                        list:[
                            {
                                link:'5_1',
                                label:'Wemind'
                            },
                            {
                                link:'5_2',
                                label:this.$t('App.header.text26'),
                            },
                            {
                                link:'5_3',
                                label:this.$t('App.header.text27'),
                            },
                            {
                                link:'5_4',
                                label:this.$t('App.header.text28'),
                            },
                        ]
                    },
                    {
                        label:this.$t('App.header.text29'),
                        id: '6',
                        list:[
                            {
                                link:'6_1',
                                label:this.$t('App.header.text30'),
                            },
                            {
                                link:'6_2',
                                label:this.$t('App.header.text31'),
                            },
                            {
                                link:'6_3',
                                label:this.$t('App.header.text32'),
                            },
                        ]
                    },
                    {
                        label:this.$t('App.header.text33'),
                        id: '7',
                        list:[
                            {
                                link:'7_1',
                                label:this.$t('App.header.text34'),
                            },
                        ]
                    }
                ]
            }
        },
        computed:{
            ...mapGetters({remRatio:'remRatio',scrollType:'scrollType',lastScrollTop:'lastScrollTop',linkToType:'linkToType'}),
        },
        mounted(){
        },
        methods:{
            onMouseEnter(){
                this.hoverIstrue = true;
                if(this.hoverTime){
                    clearTimeout(this.hoverTime)
                }
            },
            onMouseLeave(){
                if(this.searchIsTrue){
                    return
                }
                this.hoverTime = setTimeout(()=>{
                    this.hoverIstrue = false;
                },800)
            },
            searchChange(){
                console.log(this.searchValue)
            },
            linkToTypeFun(data,index){
                if(index == 1){
                    if(data.link == '/home'){
                        this.$router.push({ path: data.link });
                        this.$store.commit('linkToTypeFun', {
                            linkToType: data.link,
                        })
                    }
                }
                if(index == 2){
                    
                    if(data.link == '/smartLighting'){
                        this.$router.push({ path: data.link });
                        this.$store.commit('linkToTypeFun', {
                            linkToType: data.link,
                        })
                    }
                }
            }
        },  
        watch: {
            
            
            lastScrollTop(){
                // console.log(this.lastScrollTop)
                // if(this.lastScrollTop>3.95*this.remRatio){
                //     this.hoverTime = setTimeout(()=>{
                //         this.hoverIstrue = false;
                //     },800)
                // }
            },
            scrollType: function () {
                // console.log(this.scrollType,this.lastScrollTop)
                if(this.scrollType == 'down'){
                    this.onMouseLeave()
                }else{
                    this.onMouseEnter()
                }
            }
        }
    }
</script>

<style lang="less">
    .headers_template{
        // width: 100%;
        position: fixed;
        top: -3.95rem;left: 0;right: 0;
        z-index: 10;
        transition: top 375ms cubic-bezier(.4,0,1,1), background-color .15s cubic-bezier(.4,0,.2,1) 0s, color .15s cubic-bezier(.4,0,.2,1) 0s;
        &.show{
            top: 0;
        }
        &.hover{
            background-color: rgba(255, 255, 255, 1);
            box-shadow: 0 0 50px rgba(0, 0, 0, .05);
            &:before {
                background-color: #e7e9ed;
                bottom: 0;
                content: " ";
                height: 1px;
                position: absolute;
                width: 100%;
                z-index: 1;
            }
            .text{
                color: rgba(26, 26, 26, 1);
            }
            .left_box{
                .logo{
                    background-image: url('../img/logo_yzs_h.png');
                }
            }
            .right_box{
                .search_btn{
                    background-image: url('../img/icon_search_h.png');
                }
                .language_btn{
                    color: rgba(51, 51, 51, 1);
                }
                .line_bar{
                    background-color: rgba(153, 153, 153, 1)
                }
            }
        }
        .text{
            font-weight: 500;
            font-size: 0.92rem;
            color: #FFFFFF;
        }
        .marginAuto{
            margin: 0 auto;
            width: 73.12%;
            min-width: 1200px;
            height: 3.95rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .left_box{
            width: 25rem;
            display: flex;
            align-items: center;
            .logo{
                width:6.45rem;
                height:1.97rem;
                background-image: url('../img/logo_yzs.png');
                background-size: 100% 100%;
                background-position: center;
                cursor: pointer;
            }
            .title{
                margin-left: 2.76rem;
                font-family: PingFang SC, PingFang-SC;
            }
        }
        .nav_box{
            display: flex;
            align-items: center;
            .nav_btn{
                position: relative;
                z-index: 2;
                height: 3.95rem;
                line-height: 3.95rem;
                box-sizing: border-box;
                font-family: PingFang SC, PingFang-SC;
                cursor: pointer;
                padding: 0 0.5rem;
            }
            .nav_li{
                position: relative;
                margin-right: 1.35rem;
                &:hover{
                    .nav_btn{
                        height: 3.95rem;
                        line-height: 3.95rem;
                        color: rgba(0, 46, 172, 1);
                        border-bottom: 3px solid rgba(0, 46, 172, 1);
                        &.select{
                            color: rgba(0, 46, 172, 1);
                        }
                    }
                    .nav_dropdown_list{
                        padding: 0.5rem 0;
                    }
                    .li_1{
                        height: calc(2.9rem + 1rem);
                    }
                    .li_3{
                        height: calc(8.7rem + 1rem);
                    }
                    .li_4{
                        height: calc(11.6rem + 1rem);
                    }
                    .li_6{
                        height: calc(17.4rem + 1rem);
                    }
                    .li_7{
                        height: calc(20.3rem + 1rem);
                    }
                }
            }
            .nav_dropdown_list{
                // display: none;
                position: absolute;
                width: 9.4rem;
                left: calc(50% - 4.7rem);
                top: 3.95rem;
                background: #FFFFFF;
                overflow: hidden;
                height: 0;
                transition: all 0.5s;
                box-shadow: 0 -8px #fff, 2px 4px 12px rgba(0, 0, 0, .08);
                .dropdown_li{
                    font-family: PingFang SC, PingFang-SC;
                    font-weight: 500;
                    font-size: 0.92rem;
                    color: #666666;
                    text-align: center;
                    margin-bottom: 0.5rem;
                    cursor: pointer;
                    height: 2.4rem;
                    line-height: 2.4rem;
                    &:hover{
                        color: rgba(0, 46, 172, 1);
                    }
                }
            }
        }
        .search_box{
            width: 100%;
            display: flex;
            justify-content: center;
            .search_input{
                width: 42.63rem;
                .el-input__inner::-webkit-input-placeholder { /* Edge */
                    font-family: PingFang SC, PingFang-SC;
                    font-weight: 400;
                    font-size: 0.92rem;
                    color: #606266;
                }

                .el-input__inner:-ms-input-placeholder { /* Internet Explorer 10-11 */
                    font-family: PingFang SC, PingFang-SC;
                    font-weight: 400;
                    font-size: 0.92rem;
                    color: #606266;
                }

                .el-input__inner::placeholder {
                    font-family: PingFang SC, PingFang-SC;
                    font-weight: 400;
                    font-size: 0.92rem;
                    color: #606266;
                }
                .el-input__inner{
                    height: 2.37rem;
                    line-height: 2.37rem;
                    background: #F2F4F5;
                    border-radius: 2.83rem 2.83rem 2.83rem 2.83rem;
                    padding-left: 0.75rem;
                }
                .el-input__suffix{
                    width: 1rem;
                    height: 2.37rem;
                    // line-height: 2.37rem;
                    right: 0.93rem;
                    .el-input__suffix-inner{
                        display: flex;
                        width: 1rem;
                        height: 2.37rem;
                        align-items: center;
                    }
                    img{
                        width: 1rem;
                        height: 1rem;
                        cursor: pointer;
                    }
                }
            }
            .btn{
                margin-left: 1.5rem;
                padding: 0.5rem;
                font-family: PingFang SC, PingFang-SC;
                font-weight: 400;
                font-size: 0.92rem;
                color: #606266;
                cursor: pointer;
                font-family: PingFang SC, PingFang-SC;
                font-weight: 400;
                font-size: 0.92rem;
                color: #606266;
            }
        }
        .right_box{
            width: 25rem;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .search_btn{
                width: 1.58rem;
                height: 1.58rem;
                background-image: url('../img/icon_search.png');
                background-position: center;
                background-size: 100% 100%;
                cursor: pointer;
            }
            .line_bar{
                margin: 0 2.5rem;
                width: 2px;
                height: 1.2rem;
                background-color:  #FFFFFF;
            }
            .language_btn{
                font-family: PingFang SC, PingFang-SC;
                font-weight: 500;
                font-size: 1.18rem;
                color: #FFFFFF;
            }
        }
    }

</style>